import { Handle, Position } from 'reactflow';
import { useState, useEffect } from 'react';
import { Modal, Button, Input, Select } from 'antd';

const { Option } = Select;

export default function ActionNode({ data }) {
  const predefinedActions = ['Send Email', 'Assign to Role', 'Assign to User', 'Update Field'];

  const [actionType, setActionType] = useState(data.actionType || 'Send Email');
  const [target, setTarget] = useState(data.target || '');

  // Email fields
  const [to, setTo] = useState(data.to || '');
  const [subject, setSubject] = useState(data.subject || '');
  const [body, setBody] = useState(data.body || '');
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Update Field action 
  const [updateField, setUpdateField] = useState(data.updateField || '');
  const [updateValue, setUpdateValue] = useState(data.updateValue || '');

// Sync back to data
  useEffect(() => {
    data.actionType = actionType;
    data.target = target;
    data.to = to;
    data.subject = subject;
    data.body = body;
    data.updateField = updateField;
    data.updateValue = updateValue;
  }, [actionType, target, to, subject, body, updateField, updateValue]);

  const hasTargetInput = actionType === 'Assign to Role' || actionType === 'Assign to User';
  const isSendEmail = actionType === 'Send Email';
  const isUpdateField = actionType === 'Update Field';

  const dynamicHeight = 180;

const options =
  actionType === "Assign to Role"
    ? data.roleDataList.map((r) => ({
        value: r.id,          // 👈 role ID
        label: r.role_name,   // 👈 display text
      }))
    : data.userDataList.map((u) => ({
        value: u.id,          // 👈 user ID
        label: u.email,       // 👈 display text
      }));


  return (
    <div
      className="action-node"
      style={{
        background: '#bfdbfe',
        border: '2px solid #3b82f6',
        borderRadius: 12,
        padding: 10,
        width: 230,
        height: dynamicHeight,
        position: 'relative',
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      }}
    >
      {data.onRemove && (
        <button
          onClick={data.onRemove}
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            background: 'red',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            fontSize: 10,
            padding: '2px 4px',
            cursor: 'pointer',
          }}
        >
          X
        </button>
      )}

      <strong>Action</strong>

      <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
        
        {/* Action Type */}
        <select
          value={actionType}
          onChange={(e) => setActionType(e.target.value)}
          style={{ padding: 4, borderRadius: 4 }}
        >
          {predefinedActions.map((act) => (
            <option key={act} value={act}>
              {act}
            </option>
          ))}
        </select>

        {/* Assign to Role/User */} 
        {hasTargetInput && (
          <Select
            showSearch
            value={target ?? undefined}   // target = ID
            placeholder={`Select ${
              actionType === "Assign to Role" ? "Role" : "User"
            }`}
            style={{ width: 210 }}
            onChange={(value) => setTarget(value)} // 👈 receives ID
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children
                ?.toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {options.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        )}


        {/* Update Field Action */} 
        {isUpdateField && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 6,
              marginTop: 6
            }}
          > 

            {/* Field selector */}
            <select
              value={updateField}
              onChange={(e) => setUpdateField(e.target.value)}
              style={{ padding: 4, borderRadius: 4 }}
            >
              <option value="">Select Field</option>
              {(data.fields || []).map((f) => (
                <option key={f} value={f}>
                  {f}
                </option>
              ))}
            </select>

            {/* Value input */}
            <Input
              placeholder="Value"
              value={updateValue}
              onChange={(e) => setUpdateValue(e.target.value)}
            />
          </div>
        )}  

        {/* Send Email */}
        {isSendEmail && (
          <Button size="small" onClick={() => setIsModalOpen(true)}>
            Edit Email
          </Button>
        )}

        <Modal
          title="Email Details"
          open={isModalOpen}
          onOk={() => setIsModalOpen(false)}
          onCancel={() => setIsModalOpen(false)}
        >
          <Input
            placeholder="To"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            style={{ marginBottom: 10 }}
          />
          <Input
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{ marginBottom: 10 }}
          />
          <Input.TextArea
            placeholder="Body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            autoSize={{ minRows: 6, maxRows: 12 }}
          />
        </Modal>
      </div>

      <Handle type="target" position={Position.Top} style={{ background: '#555' }} />
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: '#555', width: 10, height: 10, borderRadius: '50%' }}
      />
    </div>
  );
}
